import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EstatusJSON } from "../../models/EstatusJSON";
import { environment } from '../../../../../environments/environment';
import { IApiBase } from './Interface/IApiBase.interface';
import { CatalogPaginationRequest } from '../../models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from '../../models/Filter/FilterRequest';
@Injectable({
    providedIn: 'root'
  })


export class AzureStorageAPIService implements IApiBase{
  private configUrl: string;

  constructor(
    private http: HttpClient){
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error('Method not implemented.');
  }
  update(datos: any) {
    throw new Error('Method not implemented.');
  }
  delete(id: any) {
    throw new Error('Method not implemented.');
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error('Method not implemented.');
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }

  GetFileUrl( folderPath : string, fileName : string){
    console.log(this.configUrl + "/api/LocationCategory/GetFileUrl");
    return this.http.get<EstatusJSON>(this.configUrl + "/api/AzureStorage/GetFileUrl?folderPath="+folderPath+"&fileName="+fileName)
  }

  GetFolderFilesUrl( folderPath : string){
    console.log(this.configUrl + "/api/LocationCategory/GetFileUrl");
    return this.http.get<EstatusJSON>(this.configUrl + "/api/AzureStorage/GetFolderFilesUrl?folderPath="+folderPath)
  }
}
